import { NON_REP_LABEL } from 'shared/constants/NON_REP_LABEL';

export const nonRepLabel = (country_code: string) => {
  return country_code?.toLowerCase() === 'us' ? NON_REP_LABEL.personal_profile : NON_REP_LABEL.freelance;
};
